<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <span class="note"><i style="color: red">*</i> 确定要取消当前单据吗？</span>
            <div>
                <el-input style="margin-top: 30px" type="textarea" :rows="2" placeholder="请输入取消原因" v-model="textarea" @blur="check"></el-input>
            </div>
        </div>
        <CloseButton type="confirm" @confirm="SurgeryCencelRescue" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `SurgeryCencelRescue`,
    props: {

    },
    data() {
        return {
            title: `取消单据`,
            token: this.$route.query.token,
            recordType: this.$route.query.recordType,
            id: this.$route.query.surgery_id,
            AfterOtherEventClickProc: this.$root.AfterOtherEventClickProc,
            data: {},
            msg: `closeWindow`,
            textarea: ``
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
    },
    computed: {
    },
    methods: {
        SurgeryCencelRescue() {
            let that = this
            if (!that.check()) return false
            return new Promise((resolve) => {
                let req = that.myaxios.put(`/api/Intraoperative/Anaesthesia/SurgeryCencelRescue?id=${this.id}&recordType=${this.recordType}&reason=${this.textarea}`)
                req.then(data => {
                    that.data = { surgeryId: this.$route.query.surgery_id }
                    that.msg = `ok`
                    that.sendMessage()
                    if (that.AfterOtherEventClickProc) {
                        that.afterExecProc()
                    }
                }).catch(e => { console.log(e) })
            })
        },
        check() {
            if (this.textarea === ``) {
                this.$message.warning(`取消原因不能为空`)
                return false
            }
            return true
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        // 取消手术后处理
        afterExecProc() {
            return new Promise((resolve) => {
                let req = this.myaxios.post(`/api/Intraoperative/Anaesthesia/AfterOtherEventProc?surgeryId=${this.id}&recordType=${this.recordType}&actionType='取消单据'`)
                req.then(data => {
                }).catch(e => { console.log(e) })
            })
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/SurgeryCencelRescue.vue